var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{attrs:{"color":_vm.getColor(_vm.value),"small":_vm.small,"to":_vm.to}},[_vm._t("default",[_vm._v(_vm._s(_vm.value))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }